import { AppContext, Features } from "@lightspeed-invoicing/core-client/frontend"
import $ from "jquery"
import { compact, isEqual } from "lodash"
import React, { Component } from "react"
import { FormattedMessage, FormattedNumber, defineMessages, injectIntl } from "react-intl"
import { connect } from "react-redux"
import { withRouter } from "react-router"
import { Link, Redirect } from "react-router-dom"
import Toggle from "react-toggle"
import EventBus from "../../common/EventBus"
import GlobalHelper from "../../common/GlobalHelper.jsx"
import { Alert } from "../../common/alert/Alert"
import ActionButton from "../../common/button/actionbutton.component.jsx"
import ConfirmButton from "../../common/button/confirmbutton.component.jsx"
import DocumentUploaderDropZone from "../../common/document-uploader/dropzone.component.jsx"
import MeasureInputForm from "../../common/form/measureinput.component.jsx"
import MoneyInputForm from "../../common/form/moneyinput.component.jsx"
import FormRow from "../../common/form/row.component.jsx"
import Icon from "../../common/icon/icon.component.jsx"
import ImageUploaderDropZone from "../../common/image-uploader/dropzone.component.jsx"
import LabelSelect from "../../common/label/selection.component.jsx"
import RichTextEditor from "../../common/rich-text/editor.component.jsx"
import InputUnitOfMeasure from "../../common/unit-of-measure/input.component.jsx"
import SelectUnitOfMeasure from "../../common/unit-of-measure/select.component.jsx"
import DeprecatedUserSelect from "../../common/user/selection.component.jsx"
import ExternalLink from "../../state/integration/ExternalLink"
import ProductPrice from "../../state/product-price/ProductPrice"
import ProductPriceService from "../../state/product-price/ProductPriceService"
import { updateProduct } from "../../state/product/ProductActions"
import { PRODUCT_TYPE, PRODUCT_UPDATE_OPTION } from "../../state/product/Types"
import { createNewMultiProductPricePayload } from "../../utils/product-price/utils"
import PricingHelper from "../PricingHelper.jsx"
import BillingMethodCostLabel from "../billing-method/costlabel.component.jsx"
import BillingMethodLabel from "../billing-method/label.component.jsx"
import BillingMethodPriceLabel from "../billing-method/pricelabel.component.jsx"
import BillingMethodPricingBracketLabel from "../billing-method/pricingbracketslabel.component.jsx"
import BillingMethodSelector from "../billing-method/select.component.jsx"
import FormulaInput from "../formulainput.component.jsx"
import MatrixEditSectionWrapper from "../variant/section/MatrixEditSectionWrapper"
import AssemblyEditForm from "./assembly.component.jsx"
import CustomAttributeDefinitionForm from "./components/CustomAttributesDefinition/CustomAttributeDefinitionForm"
import ProductBrandFieldSelect from "./components/ProductBrandFieldSelect"
import ProductPriceEditForm from "./components/ProductPriceEditForm"
import ConstraintEditForm from "./constraints.component"
import CustomBracketModal from "./custom-bracket/modal.component.jsx"
import "./edit.component.css"
import MatrixEditForm from "./matrix.component"
import PricingStrategySelector from "./pricing-strategy/select.component.jsx"
const uuidv4 = require("uuid/v4")


const messages = defineMessages({
    product_name_placeholder: {
        id: "product.form.edit.product_name_placeholder",
        defaultMessage: "Name of the product"
    },
    sku_placeholder: {
        id: "product.form.edit.sku_placeholder",
        defaultMessage: "SKU of the product"
    },
    barcode_placeholder: {
        id: "product.form.edit.barcode_placeholder",
        defaultMessage: "Barcode of the product"
    },
    upc_placeholder: {
        id: "product.form.edit.upc_placeholder",
        defaultMessage: "UPC of the product"
    },
    ean_placeholder: {
        id: "product.form.edit.ean_placeholder",
        defaultMessage: "EAN of the product"
    },
    manufacturer_sku_placeholder: {
        id: "product.form.edit.manufacturer_sku_placeholder",
        defaultMessage: "Manufacturer SKU of the product"
    },
    product_short_description_placeholder: {
        id: "product.form.edit.short_description_description.short_description_placeholder",
        defaultMessage: "A few words to describe the product"
    },
    sku_description: {
        id: "product.form.edit.sku_description",
        defaultMessage: "Internal reference that won't be seen by your customers"
    },
    barcode_description: {
        id: "product.form.edit.barcode_description",
        defaultMessage: "Barcode reference so you can scan this product"
    },
    upc_description: {
        id: "product.form.edit.upc_description",
        defaultMessage: "UPC reference so you can scan this product"
    },
    ean_description: {
        id: "product.form.edit.ean_description",
        defaultMessage: "EAN reference so you can scan this product"
    },
    manufacturer_sku_description: {
        id: "product.form.edit.manufacturer_sku_description",
        defaultMessage: "Internal reference that won't be seen by your customers"
    },
    manufacturer_description: {
        id: "product.form.edit.labels.manufacturer_description",
        defaultMessage: "Manufacturers are used to classify products. They can be used in searches or filters."
    },
    vendor_description: {
        id: "product.form.edit.labels.vendor_description",
        defaultMessage: "Vendor is the supplier of the product. They can be used in searches or filters."
    },
    label_description: {
        id: "product.form.edit.labels.label_description",
        defaultMessage: "Labels are used to classify products. They can be used in searches or filters."
    },
    product_page_url_placeholder: {
        id: "product.form.edit.product_page_url_placeholder",
        defaultMessage: "A website URL of the product"
    },
    reached_max_variants_header: {
        id: "product.form.edit.product_reached_max_variants_header",
        defaultMessage: "Maximum number of variants reached"
    },
    reached_max_variants_body: {
        id: "product.form.edit.product_reached_max_variants_body",
        defaultMessage:
            "We are unable to save the product with ({currentVariantsCount}) variants. You have reached the maximum number of variants allowed ({maxNumber}). To add new variants please remove unused variants or options values."
    }
})

const allowedFields = [
    "title",
    "sku",
    "manufacturerSku",
    "upc",
    "ean",
    "barcode",
    "shortDescription",
    "longDescription",
    "type",
    "unitOfMeasure",
    "additionalUnitOfMeasure",
    "pricingStrategy",
    "billingMethods",
    "bracketSize",
    "measureMinimum",
    "defaultUnitCost",
    "defaultUnitPrice",
    "monthlyUnitCost",
    "monthlyUnitPrice",
    "yearlyUnitCost",
    "yearlyUnitPrice",
    "imageIds",
    "assembly",
    "calculator",
    "taxExempt",
    "feeExempt",
    "pricingBrackets",
    "multiCurrencyPricing",
    "attachments",
    "priceFormula",
    "costFormula",
    "isNonInventory",
    "productPageUrl",
    "customAttributeDefinitions",
    "labelIds",
    "documentIds",
    "vendorIds",
    "brandId",
]

const MATRIX_ITEMS_LIMIT = 200

class ProductEditForm extends Component {
    constructor(props, context) {
        super(props, context)

        const defaultState = this.props.defaultState || {}
        this.state = {
            id: "",
            title: "",
            sku: "",
            manufacturerSku: "",
            upc: "",
            ean: "",
            barcode: "",
            type: defaultState.type || "single",
            shortDescription: "",
            longDescription: "",
            unitOfMeasure: "piece",
            additionalUnitOfMeasure: "",
            defaultUnitCost: "0",
            defaultUnitPrice: "0",
            monthlyUnitCost: "0",
            monthlyUnitPrice: "0",
            yearlyUnitCost: "0",
            yearlyUnitPrice: "0",
            pricingStrategy: "multiplier",
            bracketSize: "1",
            measureMinimum: "0",
            priceFormula: "",
            costFormula: "",
            measureExample: "0",
            defaultCalculatedCost: "0",
            defaultCalculatedPrice: "0",
            monthlyCalculatedCost: "0",
            monthlyCalculatedPrice: "0",
            yearlyCalculatedCost: "0",
            yearlyCalculatedPrice: "0",
            formStatus: "",
            assemblyForm: "",
            matrixForm: "",
            taxExempt: false,
            feeExempt: false,
            matrix: null,
            assembly: null,
            calculator: null,
            billingMethods: ["one-time"],
            terms: [],
            formulas: [],
            hasCalculator: false,
            labelIds: [],
            tagIds: [],
            manufacturerIds: [],
            vendorIds: [],
            brandId: null,
            images: [],
            imageIds: [],
            documents: [],
            documentIds: [],
            pricingBrackets: [],
            attachments: [],
            possibleAttachments: [],
            customBracketModal: "",
            externalLink: null,
            bookingFeatureEnabled: AppContext.hasFeatureIntegration(Features.Booking),
            attachmentFeatureEnabled: AppContext.hasFeatureIntegration(Features.ProductAttachment),
            bookingEnabled: false,
            eventTitle: "",
            eventDescription: "",
            eventDuration: "",
            preBufferDuration: "",
            postBufferDuration: "",
            calendars: [],
            currency: AppContext.getAccount().attributes.currency,
            multiCurrencyPricing: [],
            currentCurrency: AppContext.getAccount().attributes.currency,
            modal: "",
            productDeletedAt: "",
            unarchiveLoading: false,
            isNonInventory: false,
            productPageUrl: "",
            customAttributeDefinitions: [],
            isLoading: true,
            isSubmitting: false,
            isError: false,
            isVariantLimitAlertVisible: false,
            productPrices: [],
            updatedProductPrices: []
        }
        this.matrix = null
        this.matrixRef = React.createRef()
        this.handleFormChange = this.handleFormChange.bind(this)
        this.handleUnitOfMeasureChange = this.handleUnitOfMeasureChange.bind(this)
        this.deleteProduct = this.deleteProduct.bind(this)
        this.unarchiveProduct = this.unarchiveProduct.bind(this)
        this.onMatrixChange = this.onMatrixChange.bind(this)
        this.onTagsSelectChange = this.onTagsSelectChange.bind(this)
        this.onManufacturersSelectChange = this.onManufacturersSelectChange.bind(this)
        this.onVendorSelectChange = this.onVendorSelectChange.bind(this)
        this.onBrandSelectChange = this.onBrandSelectChange.bind(this)
        this.handleAssemblyChange = this.handleAssemblyChange.bind(this)
        this.handleImageChange = this.handleImageChange.bind(this)
        this.handleDocumentChange = this.handleDocumentChange.bind(this)
        this.handleRichTextChange = this.handleRichTextChange.bind(this)
        this.handleBracketSizeChange = this.handleBracketSizeChange.bind(this)
        this.handleCalculatorChange = this.handleCalculatorChange.bind(this)
        this.handleMeasureMinimumChange = this.handleMeasureMinimumChange.bind(this)
        this.openCustomBracketModal = this.openCustomBracketModal.bind(this)
        this.handleCloseCustomBracketModal = this.handleCloseCustomBracketModal.bind(this)
        this.handleChangeCustomBrackets = this.handleChangeCustomBrackets.bind(this)
        this.handleFocus = this.handleFocus.bind(this)
        this.submit = this.submit.bind(this)
        this.toggleBookingEnabled = this.toggleBookingEnabled.bind(this)
        this.handleAdditionalUnitOfMeasureChange = this.handleAdditionalUnitOfMeasureChange.bind(this)
        this.showProductPageUrl = this.showProductPageUrl.bind(this)
        this.productPageUrlInputIsDisabled = this.productPageUrlInputIsDisabled.bind(this)
        this.saveProductPrice = this.saveProductPrice.bind(this)
    }

    componentDidMount() {
        this.setInitialState()
    }

    
    componentDidUpdate(prevProps, prevState) {
        if (prevProps.product !== this.props.product) {
            this.setInitialState()
        }
        if (
            prevState.vendorIds !== this.state.vendorIds ||
            prevState.brandId !== this.state.brandId ||
            prevState.manufacturerIds !== this.state.manufacturerIds ||
            prevState.tagIds !== this.state.tagIds
        ) {
            this.onLabelIdsChange()
        }
    }

    setInitialState() {
        this.setState({ isLoading: true })
        const product = this.props.product
        $("[data-toggle=\"tooltip\"]").tooltip()

        if (product && product.id) {
            $("#productType").attr("disabled", "disabled")
            let assembly = null
            if (product.attributes.assembly) {
                assembly = {
                    parts: product.attributes.assembly.attributes.parts.map(p => {
                        return {
                            id: p.id,
                            type: p.attributes.type,
                            name: p.attributes.name,
                            required: p.attributes.required,
                            sequence: p.attributes.sequence,
                            choices: p.attributes.choices.map(c => {
                                return {
                                    id: c.id,
                                    productId: c.attributes.productId,
                                    additionalUnitPrice: c.attributes.additionalUnitPrice,
                                    sequence: c.attributes.sequence
                                }
                            })
                        }
                    })
                }
            }
            EventBus.dispatch(EventBus.TopicUploaderImagesLoaded, {
                images: product.attributes.images
            })

            EventBus.dispatch(EventBus.TopicUploaderDocumentsLoaded, {
                documents: [...product.attributes.documents]
            })

            let calculator = null
            let terms = []
            let formulas = []
            if (product.attributes.calculator) {
                terms = product.attributes.calculator.attributes.terms.map(term => {
                    return {
                        name: term.attributes.name,
                        simulation: "",
                        calculatorTermId: term.id,
                        variableName: term.attributes.variableName
                    }
                })
                formulas = product.attributes.calculator.attributes.formulas.map(formula => {
                    return {
                        formula: formula.attributes.formula,
                        partId: formula.attributes.partId,
                        partName: "",
                        calculatorFormulaId: formula.id
                    }
                })
                calculator = {
                    terms: terms,
                    formulas: formulas
                }
            }

            let pricingBrackets = []
            if (product.attributes.pricingBrackets) {
                pricingBrackets = product.attributes.pricingBrackets.map(bracket => {
                    return {
                        id: bracket.id,
                        fromMeasure: bracket.attributes.fromMeasure,
                        toMeasure: bracket.attributes.toMeasure,
                        cost: bracket.attributes.cost,
                        price: bracket.attributes.price,
                        monthlyCost: bracket.attributes.monthlyCost,
                        monthlyPrice: bracket.attributes.monthlyPrice,
                        yearlyCost: bracket.attributes.yearlyCost,
                        yearlyPrice: bracket.attributes.yearlyPrice,
                        sequence: bracket.attributes.sequence,
                        multiCurrencyPricing: bracket.attributes.multiCurrencyPricing.map(a => {
                            return {
                                currency: a.attributes.currency,
                                oneTimePrice: a.attributes.oneTimePrice,
                                monthlyPrice: a.attributes.monthlyPrice,
                                yearlyPrice: a.attributes.yearlyPrice
                            }
                        })
                    }
                })
            }
            let newState = {
                id: product.id,
                title: product.attributes.title,
                sku: product.attributes.sku,
                manufacturerSku: product.attributes.manufacturerSku,
                barcode: product.attributes.barcode,
                upc: product.attributes.upc,
                ean: product.attributes.ean,
                type: product.attributes.type,
                taxExempt: product.attributes.taxExempt,
                feeExempt: product.attributes.feeExempt,
                shortDescription: product.attributes.shortDescription,
                longDescription: product.attributes.longDescription,
                unitOfMeasure: product.attributes.unitOfMeasure,
                additionalUnitOfMeasure: product.attributes.additionalUnitOfMeasure,
                pricingStrategy: product.attributes.pricingStrategy,
                billingMethods: product.attributes.billingMethods,
                bracketSize: parseInt(product.attributes.bracketSize) <= 0 ? "1" : product.attributes.bracketSize,
                measureMinimum: product.attributes.measureMinimum,
                defaultUnitCost: product.attributes.defaultUnitCost,
                defaultUnitPrice: product.attributes.defaultUnitPrice,
                monthlyUnitCost: product.attributes.monthlyUnitCost,
                monthlyUnitPrice: product.attributes.monthlyUnitPrice,
                yearlyUnitCost: product.attributes.yearlyUnitCost,
                yearlyUnitPrice: product.attributes.yearlyUnitPrice,
                priceFormula: product.attributes.priceFormula,
                costFormula: product.attributes.costFormula,
                matrix: product.attributes.matrix,
                assembly: assembly,
                labelIds: product.attributes.labels.map(l => l.id),
                manufacturerIds: product.attributes.labels.filter(l => l.attributes.type === "manufacturer").map(label => label.id),
                vendorIds: product.attributes.labels.filter(l => l.attributes.type === "vendor").map(label => label.id),
                brandId: product.attributes.labels.find(l => l.attributes.type === "brand")?.id,
                tagIds: product.attributes.labels.filter(l => l.attributes.type === "tag").map(label => label.id),
                imageIds: product.attributes.images.map(im => im.id),
                images: product.attributes.images,
                documentIds: product.attributes.documents.map(doc => doc.id),
                documents: [...(product.attributes.documents || [])],
                customAttributeDefinitions: [...(product.attributes.customAttributeDefinitions || [])],
                attachments: product.attributes.attachments.map(a => {
                    return {
                        externalId: a.attributes.externalId,
                        integrationKey: a.attributes.integrationKey
                    }
                }),
                multiCurrencyPricing: product.attributes.multiCurrencyPricing.map(a => {
                    return {
                        currency: a.attributes.currency,
                        oneTimePrice: a.attributes.oneTimePrice,
                        monthlyPrice: a.attributes.monthlyPrice,
                        yearlyPrice: a.attributes.yearlyPrice
                    }
                }),
                calculator: calculator,
                terms: terms,
                formulas: formulas,
                hasCalculator: product.attributes.calculator !== null,
                pricingBrackets: pricingBrackets,
                externalLink: product.attributes.externalLink,
                bookingFeatureEnabled: AppContext.hasFeatureIntegration(Features.Booking),
                productDeletedAt: product.attributes.deletedAt,
                isNonInventory: product.attributes.isNonInventory,
                productPageUrl: product.attributes.pageUrl,
                trackSerialNumber: product.attributes.trackSerialNumber,
                productPrices: product.attributes.productPrices
            }

            if (product.attributes.bookingSpecification) {
                newState.bookingEnabled = product.attributes.bookingSpecification.attributes.enabled
                newState.eventTitle = product.attributes.bookingSpecification.attributes.eventTitle
                newState.eventDescription = product.attributes.bookingSpecification.attributes.eventDescription
                newState.eventDuration = this.formatDurationToTime(product.attributes.bookingSpecification.attributes.duration)
                newState.preBufferDuration = this.formatDurationToTime(product.attributes.bookingSpecification.attributes.preBuffer)
                newState.postBufferDuration = this.formatDurationToTime(product.attributes.bookingSpecification.attributes.postBuffer)
                newState.calendars = product.attributes.bookingSpecification.attributes.userIds
            }
            this.setState(newState)
        }

        AppContext.getApiClient()
            .get("/product-attachments")
            .then(res => {
                this.setState({
                    possibleAttachments: res.data
                })
            })

        //if coming back from matrix item edit scroll to item row
        if (this.props.location.hash) {
            const hash = this.props.location.hash
            setTimeout(() => {
                const id = hash.replace("#", "")
                const element = document.getElementById(id)
                if (element) element.scrollIntoView()
            }, 0)
        }

        this.setState({ isLoading: false })
    }

    formatDurationToTime(duration) {
        const totalMinutes = duration / 60 / 1000 / 1000 / 1000 // nanoseconds
        const hours = Math.floor(totalMinutes / 60)
        const minutes = Math.floor((totalMinutes - hours * 60) / 60)
        return this.pad(hours, 2) + ":" + this.pad(minutes, 2)
    }

    formatTimeToDuration(time) {
        const chunks = time.split(":")
        return (parseInt(chunks[0]) * 60 + parseInt(chunks[1])) * 60 * 1000 * 1000 * 1000 // nanoseconds
    }

    pad(n, width, z) {
        z = z || "0"
        n = n + ""
        return n.length >= width ? n : new Array(width - n.length + 1).join(z) + n
    }

    deleteProduct(event) {
        const product = this.props.product
        AppContext.getApiClient()
            .delete("/products/" + product.id)
            .then(response => {
                let formStatus = ""
                let url = "/matrices/catalog"
                if (this.state.type === PRODUCT_TYPE.SINGLE) {
                    url = "/products/catalog"
                }
                if (!response.error) {
                    formStatus = <Redirect to={{ pathname: url }} />
                }
                this.setState({ formStatus: formStatus })
            })

        event.preventDefault()
    }

    unarchiveProduct(event) {
        event.preventDefault()
        const product = this.props.product
        AppContext.getApiClient()
            .put("/products/" + product.id + "/unarchive", {})
            .then(response => {
                let formStatus = ""
                let url = "/matrices/catalog"
                if (this.state.type === PRODUCT_TYPE.SINGLE) {
                    url = "/products/catalog"
                }
                if (!response.error) {
                    formStatus = <Redirect to={{ pathname: url }} />
                }
                this.setState({ formStatus: formStatus })
            })

        event.preventDefault()
    }

    onMatrixChange(matrix) {
        this.setState({
            matrix: matrix
        })
    }

    productExists() {
        const product = this.props.product
        if (product && product.id) {
            return true
        }
        return false
    }

    isFieldDirty(field) {
        const product = this.props.product?.attributes
        if (!product) {
            return true
        }

        switch (field) {
        case "labelIds":
            return !isEqual(
                product.labels?.map(l => l.id),
                this.state.labelIds
            )
        case "documentIds":
            return !isEqual(
                product.documents?.map(d => d.id),
                this.state.documentIds
            )
        case "productPageUrl":
            return !isEqual(product.pageUrl, this.state.productPageUrl)
        case "vendorIds":
            if (!product.vendorIds && this.state.vendorIds.length == 0) {
                return false
            } else {
                return !isEqual(product[field], this.state[field])
            }
        case "customAttributeDefinitions":
            if (!product.customAttributeDefinitions && this.state.customAttributeDefinitions.length == 0) {
                return false
            } else {
                return !isEqual(product[field], this.state[field])
            }
        default:
            return !isEqual(product[field], this.state[field])
        }
    }

    extractProductFields() {
        const product = this.props.product
        let updates = {}

        for (let i = 0; i < allowedFields.length; i++) {
            let field = allowedFields[i]
            if (this.isFieldDirty(field)) {
                updates[field] = this.state[field]
            }
        }

        if (!this.state.hasCalculator || this.state.type !== PRODUCT_TYPE.ASSEMBLY) {
            updates.calculator = null
        } else {
            updates.calculator = {
                terms: this.state.terms,
                formulas: this.state.formulas
            }
        }

        if (updates.calculator === product.attributes.calculator) {
            delete updates.calculator
        }

        if (updates.measureMinimum === "") {
            updates.measureMinimum = "0"
        }

        if (this.state.bookingFeatureEnabled) {
            updates.bookingSpecification = {
                enabled: this.state.bookingEnabled,
                eventTitle: this.state.eventTitle,
                eventDescription: this.state.eventDescription,
                duration: this.formatTimeToDuration(this.state.eventDuration),
                preBuffer: this.formatTimeToDuration(this.state.preBufferDuration),
                postBuffer: this.formatTimeToDuration(this.state.postBufferDuration),
                userIds: this.state.calendars
            }
        }
        if (GlobalHelper.IsFeatureFlagEnabled("matrixV2")) {
            if (this.matrixRef?.current?.didUpdate()) {
                updates["matrix"] = this.matrixRef?.current?.getPayload()
            }
        } else if (this.state.matrix) {
            updates["matrix"] = this.state.matrix
        }
        return updates
    }

    isFormDirty() {
        return allowedFields.some(field => this.isFieldDirty(field))
    }

    saveProductPrice(productId) {
        let payload = { productPrices: createNewMultiProductPricePayload(this.state.updatedProductPrices) }
        return ProductPriceService.CreateMulti(productId, payload)
    }

    saveProduct() {
        if (this.productExists()) {
            const product = this.props.product
            const updates = this.extractProductFields()

            return AppContext.getApiClient()
                .patch("/products/" + product.id, updates)
                .then(res => {
                    this.saveProductPrice(product.id)
                    return res
                })
        } else {
            let calculator = {
                terms: this.state.terms,
                formulas: this.state.formulas
            }
            if (!this.state.hasCalculator) {
                calculator = null
            }
            let bookingSpecification = null
            if (this.state.bookingFeatureEnabled) {
                bookingSpecification = {
                    enabled: this.state.bookingEnabled,
                    eventTitle: this.state.eventTitle,
                    eventDescription: this.state.eventDescription,
                    duration: this.formatTimeToDuration(this.state.eventDuration),
                    preBuffer: this.formatTimeToDuration(this.state.preBufferDuration),
                    postBuffer: this.formatTimeToDuration(this.state.postBufferDuration),
                    userIds: this.state.calendars
                }
            }
            return AppContext.getApiClient()
                .post("/products", {
                    sku: this.state.sku,
                    manufacturerSku: this.state.manufacturerSku,
                    upc: this.state.upc,
                    barcode: this.state.barcode,
                    ean: this.state.ean,
                    title: this.state.title,
                    shortDescription: this.state.shortDescription,
                    longDescription: this.state.longDescription,
                    type: this.state.type,
                    taxExempt: this.state.taxExempt,
                    feeExempt: this.state.feeExempt,
                    pricingStrategy: this.state.pricingStrategy,
                    billingMethods: this.state.billingMethods,
                    bracketSize: this.state.bracketSize,
                    pricingBrackets: this.state.pricingBrackets,
                    measureMinimum: this.state.measureMinimum || "0",
                    unitOfMeasure: this.state.unitOfMeasure,
                    additionalUnitOfMeasure: this.state.additionalUnitOfMeasure,
                    defaultUnitCost: this.state.defaultUnitCost,
                    defaultUnitPrice: this.state.defaultUnitPrice,
                    monthlyUnitCost: this.state.monthlyUnitCost,
                    monthlyUnitPrice: this.state.monthlyUnitPrice,
                    yearlyUnitCost: this.state.yearlyUnitCost,
                    currency: this.state.currency,
                    yearlyUnitPrice: this.state.yearlyUnitPrice,
                    labelIds: this.state.labelIds,
                    imageIds: this.state.imageIds,
                    documentIds: this.state.documentIds,
                    matrix: GlobalHelper.IsFeatureFlagEnabled("matrixV2") ? this.matrixRef?.current?.getPayload() : this.state.matrix,
                    assembly: this.state.assembly,
                    priceFormula: this.state.priceFormula,
                    costFormula: this.state.costFormula,
                    attachments: this.state.attachments,
                    multiCurrencyPricing: this.state.multiCurrencyPricing,
                    calculator: calculator,
                    bookingSpecification: bookingSpecification,
                    isNonInventory: this.state.isNonInventory,
                    productPageUrl: this.state.productPageUrl,
                    customAttributeDefinitions: this.state.customAttributeDefinitions
                })
                .then(res => {
                    this.saveProductPrice(res.id)
                    return res
                })
        }
    }

    submit(shouldClose) {
        this.setState({ isSubmitting: true })

        return this.saveProduct().then(response => {
            let formStatus = ""

            if (!response.error) {
                if (shouldClose) {
                    let url = "/matrices/catalog"
                    let newState = null
                    if (this.state.type === PRODUCT_TYPE.SINGLE) {
                        url = "/products/catalog"
                    }
                    if (!this.productExists()) {
                        newState = {
                            messageCode: "product_added"
                        }
                    }
                    if (this.state.type === PRODUCT_TYPE.MATRIX_ITEM) {
                        url = this.getBackLink("")
                    }
                    formStatus = (
                        <Redirect
                            to={{
                                pathname: url,
                                state: newState
                            }}
                        />
                    )
                } else {
                    formStatus = (
                        <Redirect
                            to={{
                                pathname: "/products/edit/" + response.id
                            }}
                        />
                    )
                }
            }

            this.setState({
                formStatus: formStatus,
                isSubmitting: false
            })
        })
    }

    handleUnitOfMeasureChange(unit) {
        this.setState({
            unitOfMeasure: unit
        })
    }

    handleAdditionalUnitOfMeasureChange(unit) {
        this.setState({
            additionalUnitOfMeasure: unit
        })
    }

    handleBracketSizeChange(value) {
        if (value >= 1) {
            this.setState({
                bracketSize: value
            })
        }
    }

    handleMeasureMinimumChange(value) {
        this.setState({
            measureMinimum: value
        })
    }

    handleFormChange(event) {
        const target = event.target
        const value = target.type === "checkbox" ? target.checked : target.value
        const name = target.name

        this.setState({
            [name]: value
        })

        if (name === "title" && this.state.type === PRODUCT_TYPE.MATRIX_PARENT) {
            //this does not update the title of products until they are not updated themselves not sure if we should reload them at each change
            this.props.updateProduct({
                updateType: PRODUCT_UPDATE_OPTION.TITLE,
                value: value
            })
        }
    }

    onTagsSelectChange(labelIds) {
        this.setState({
            tagIds: labelIds
        })
    }

    onManufacturersSelectChange(labelIds) {
        this.setState({
            labelIds: this.state.tagIds.concat(labelIds),
            manufacturerIds: labelIds
        })
    }

    onVendorSelectChange(labelIds) {
        this.setState({
            vendorIds: labelIds
        })
    }

    onBrandSelectChange(labelIds) {
        this.setState({
            brandId: labelIds
        })
    }

    onLabelIdsChange() {
        let manufacturerIds = this.state.manufacturerIds
        let vendorIds = this.state.vendorIds
        let brandId = this.state.brandId
        let tagIds = this.state.tagIds

        const allLabelIds = compact([...tagIds, ...vendorIds, ...manufacturerIds, brandId])

        this.setState({
            labelIds: allLabelIds
        })
    }

    handleAssemblyChange(assembly, formulas) {
        this.setState({
            assembly: assembly,
            formulas: formulas
        })
    }

    handleCalculatorChange(terms) {
        this.setState({
            terms: terms
        })
    }

    handleImageChange(images) {
        if (images.length > 0) {
            this.setState({
                images: images,
                imageIds: images.map(i => i.id)
            })
        } else {
            this.setState({
                images: [],
                imageIds: []
            })
        }
    }

    handleDocumentChange(documents) {
        if (documents.length > 0) {
            this.setState({
                documents: documents,
                documentIds: documents.map(i => i.id)
            })
        } else {
            this.setState({
                documents: [],
                documentIds: []
            })
        }
    }

    handleRichTextChange(value) {
        this.setState({
            longDescription: value
        })
    }

    handleChangeCustomBrackets(value) {
        this.setState({
            pricingBrackets: value
        })
    }

    openCustomBracketModal(event) {
        this.setState({
            customBracketModal: (
                <CustomBracketModal
                    onClose={this.handleCloseCustomBracketModal}
                    onChange={this.handleChangeCustomBrackets}
                    value={this.state.pricingBrackets}
                    currency={this.state.currency}
                    unitOfMeasure={this.state.unitOfMeasure}
                    billingMethods={this.state.billingMethods}
                    pricingStrategy={this.state.pricingStrategy}
                />
            )
        })
        event.preventDefault()
    }

    handleCloseCustomBracketModal() {
        this.setState({
            customBracketModal: ""
        })
    }

    handleFocus(event) {
        event.target.select()
    }

    getPriceByBillingMethod(method) {
        return PricingHelper.getPriceByBillingMethod(method, this.state.currency, this.state.currentCurrency, this.state.multiCurrencyPricing, {
            "one-time": this.state.defaultUnitPrice,
            monthly: this.state.monthlyUnitPrice,
            yearly: this.state.yearlyUnitPrice
        })
    }

    setPriceByBillingMethod(method, price) {
        if (this.state.currency === this.state.currentCurrency) {
            let field = "defaultUnitPrice"
            switch (method) {
            case "monthly":
                field = "monthlyUnitPrice"
                break
            case "yearly":
                field = "yearlyUnitPrice"
                break
            }
            this.setState({ [field]: price })
            return
        }
        let multiCurrencyPricing = PricingHelper.setPriceByBillingMethod(price, method, this.state.currentCurrency, this.state.multiCurrencyPricing)
        this.setState({
            multiCurrencyPricing: multiCurrencyPricing
        })
    }

    renderCustomBracket(key, hide) {
        return (
            <div className={"mb-1 row "} key={key}>
                {this.state.customBracketModal}
                <label className="col-12 col-form-label custom-form-label strong">
                    <FormattedMessage id="product.form.edit.custom_bracket_label" defaultMessage="Custom bracket" />
                </label>
                <div className="col-12">
                    <div className={"row"}>
                        <div className="col-12">
                            <BillingMethodPricingBracketLabel
                                pricingBrackets={this.state.pricingBrackets}
                                pricingStrategy={this.state.pricingStrategy}
                                billingMethods={this.state.billingMethods}
                            />
                        </div>
                        <div className="col-12">
                            <div className="row pt-2">
                                <div className="col-12">
                                    <button className="btn btn-sm btn-primary" onClick={this.openCustomBracketModal}>
                                        <FormattedMessage id="product.form.edit.custom_bracket_edit_btn" defaultMessage="Edit custom bracket" />
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    renderCostAndPrice(hide) {
        const pricing = []
        for (let index in this.state.billingMethods) {
            const method = this.state.billingMethods[index]
            let suffix = method
            if (method === "one-time") {
                suffix = "default"
            }
            const costName = suffix + "UnitCost"
            const priceName = suffix + "UnitPrice"

            pricing.push(
                <FormRow
                    key={pricing.length}
                    className={"mb-1"}
                    labelClassName={"custom-form-label strong"}
                    name={costName}
                    style={"rows"}
                    label={<BillingMethodCostLabel billingMethod={method} pricingStrategy={this.state.pricingStrategy} />}
                    input={
                        <MoneyInputForm
                            name={costName}
                            value={this.state[costName]}
                            onChange={newValue => {
                                this.setState({ [costName]: newValue })
                            }}
                        />
                    }
                />
            )
            if (method === "one-time") {
                hide = ""
            }
            pricing.push(
                <FormRow
                    key={pricing.length}
                    className={"mb-1"}
                    labelClassName={"custom-form-label strong"}
                    name={priceName}
                    style={"rows"}
                    label={<BillingMethodPriceLabel billingMethod={method} pricingStrategy={this.state.pricingStrategy} />}
                    input={
                        <MoneyInputForm
                            name={priceName}
                            currency={this.state.currentCurrency}
                            value={this.getPriceByBillingMethod(method)}
                            multiCurrency={true}
                            onChange={newValue => {
                                this.setPriceByBillingMethod(method, newValue)
                            }}
                            onCurrencyChange={newValue => {
                                this.setState({ currentCurrency: newValue })
                            }}
                        />
                    }
                />
            )
        }
        return pricing
    }

    executeFormula() {
        for (let index in this.state.billingMethods) {
            const method = this.state.billingMethods[index]
            let suffix = method
            if (method === "one-time") {
                suffix = "default"
            }
            const costName = suffix + "UnitCost"
            const priceName = suffix + "UnitPrice"
            const resultCostName = suffix + "CalculatedCost"
            const resultPriceName = suffix + "CalculatedPrice"
            AppContext.getApiClient()
                .put("/formula-executions", {
                    formula: this.state.priceFormula,
                    measure: this.state.measureExample || "0",
                    additionalMeasure: this.state.additionalMeasureExample || "0",
                    unitCost: this.state[costName],
                    unitPrice: this.state[priceName]
                })
                .then(r => {
                    this.setState({
                        [resultPriceName]: r.attributes.result
                    })
                })
            AppContext.getApiClient()
                .put("/formula-executions", {
                    formula: this.state.costFormula,
                    measure: this.state.measureExample || "0",
                    additionalMeasure: this.state.additionalMeasureExample || "0",
                    unitCost: this.state[costName],
                    unitPrice: this.state[priceName]
                })
                .then(r => {
                    this.setState({
                        [resultCostName]: r.attributes.result
                    })
                })
        }
    }

    renderPricingConfiguration(hide) {
        let rows = []
        if (this.state.type === PRODUCT_TYPE.SINGLE) {
            switch (this.state.pricingStrategy) {
            case "multiplier":
                rows = rows.concat(this.renderCostAndPrice(hide))
                break
            case "bracket":
                rows.push(
                    <FormRow
                        key={"rows-" + rows.length}
                        className={"mb-1"}
                        labelClassName={"custom-form-label strong"}
                        style={"rows"}
                        name={"bracketSize"}
                        label={<FormattedMessage id="product.form.edit.pricing.bracket_size_label" defaultMessage="Bracket size" />}
                        input={
                            <MeasureInputForm
                                name={"bracketSize"}
                                value={this.state.bracketSize}
                                unitOfMeasure={this.state.unitOfMeasure}
                                help={
                                    <FormattedMessage
                                        id="product.form.edit.pricing.default_unit_cost_description"
                                        defaultMessage="The unit cost is used to calculate the margin"
                                    />
                                }
                                onChange={newValue => this.handleBracketSizeChange(newValue)}
                            />
                        }
                    />
                )
                rows = rows.concat(this.renderCostAndPrice(hide))
                break
            case "bracket-custom":
                rows.push(this.renderCustomBracket(rows.length, hide))
                break
            case "bulk":
                rows.push(this.renderCustomBracket(rows.length, hide))
                break
            case "custom-formula":
                rows.push(this.renderCostAndPrice(hide))
                rows.push(
                    <FormRow
                        key={"rows-" + rows.length}
                        className={"mb-1"}
                        labelClassName={"custom-form-label strong"}
                        style={"rows"}
                        name={"costFormula"}
                        label={<FormattedMessage id="product.form.edit.pricing.cost_formula_label" defaultMessage="Cost formula" />}
                        input={
                            <FormulaInput
                                name="costFormula"
                                value={this.state.costFormula}
                                onChange={this.handleFormChange}
                                id="costFormula"
                                rows="2"
                                className="form-control"
                            />
                        }
                        help={
                            <FormattedMessage
                                id="product.form.edit.pricing.cost_formula_description"
                                defaultMessage="Variables available: quantity, unit_cost, unit_price"
                            />
                        }
                    />
                )
                rows.push(
                    <FormRow
                        key={"rows-" + rows.length}
                        className={"mb-1"}
                        labelClassName={"custom-form-label strong"}
                        name={"priceFormula"}
                        label={<FormattedMessage id="product.form.edit.pricing.price_formula_label" defaultMessage="Price formula" />}
                        style={"rows"}
                        input={
                            <FormulaInput
                                name="priceFormula"
                                value={this.state.priceFormula}
                                onChange={this.handleFormChange}
                                id="priceFormula"
                                rows="2"
                                className="form-control"
                            />
                        }
                        help={
                            <FormattedMessage
                                id="product.form.edit.pricing.label_formula_description"
                                defaultMessage="Variables available: quantity, unit_cost, unit_price"
                            />
                        }
                    />
                )

                const results = []
                for (let index in this.state.billingMethods) {
                    const method = this.state.billingMethods[index]
                    let suffix = method
                    if (method === "one-time") {
                        suffix = "default"
                    }
                    const costName = suffix + "CalculatedCost"
                    const priceName = suffix + "CalculatedPrice"
                    results.push(
                        <p key={results.length} className="p-1 m-0">
                            <strong>
                                <BillingMethodLabel value={method} />
                            </strong>
                        </p>
                    )
                    if (isNaN(this.state[costName])) {
                        results.push(
                            <p key={results.length} className="p-1 m-0">
                                <small className={"text-danger"}>{this.state[costName]}</small>
                            </p>
                        )
                    } else {
                        results.push(
                            <p key={results.length} className="p-1 m-0">
                                <FormattedMessage
                                    id="product.form.edit.pricing.formula_calculated_cost_label"
                                    defaultMessage="Calculated cost: {cost}"
                                    values={{
                                        cost: (
                                            <FormattedNumber style="currency" currency={AppContext.getCurrency()} value={this.state[costName]} />
                                        )
                                    }}
                                />
                            </p>
                        )
                    }
                    if (isNaN(this.state[priceName])) {
                        results.push(
                            <p key={results.length} className="p-1 m-0">
                                <small className={"text-danger"}>{this.state[priceName]}</small>
                            </p>
                        )
                    } else {
                        results.push(
                            <p key={results.length} className="p-1 m-0 mb-1">
                                <FormattedMessage
                                    id="product.form.edit.pricing.formula_calculated_price_label"
                                    defaultMessage="Calculated price: {price}"
                                    values={{
                                        price: (
                                            <FormattedNumber style="currency" currency={AppContext.getCurrency()} value={this.state[priceName]} />
                                        )
                                    }}
                                />
                            </p>
                        )
                    }
                }

                rows.push(
                    <FormRow
                        key={"rows-" + rows.length}
                        className={"mb-1"}
                        labelClassName={"custom-form-label strong"}
                        name={"costFormula"}
                        style={"rows"}
                        input={
                            <div className={"bg-light col-md-8 col-sm-12 p-1 mt-1 rounded"}>
                                <div className={"row"}>
                                    <div className={"col-md-6"}>
                                        <p className="p-2 m-0">
                                            <strong>
                                                <FormattedMessage id="product.form.edit.pricing.formula_try_it_label" defaultMessage="Try it:" />
                                            </strong>
                                        </p>
                                        <p className="p-2 m-0">
                                            <InputUnitOfMeasure
                                                name="measureExample"
                                                value={this.state.measureExample}
                                                unit={this.state.unitOfMeasure}
                                                onChange={value => {
                                                    this.setState(
                                                        {
                                                            measureExample: value
                                                        },
                                                        this.executeFormula
                                                    )
                                                }}
                                            />
                                        </p>
                                        {this.state.additionalUnitOfMeasure ? (
                                            <p className="p-2 m-0">
                                                <InputUnitOfMeasure
                                                    name="additionalMeasureExample"
                                                    value={this.state.additionalMeasureExample}
                                                    unit={this.state.additionalUnitOfMeasure}
                                                    onChange={value => {
                                                        this.setState(
                                                            {
                                                                additionalMeasureExample: value
                                                            },
                                                            this.executeFormula
                                                        )
                                                    }}
                                                />
                                            </p>
                                        ) : (
                                            ""
                                        )}
                                    </div>
                                    <div className={"col-md-6"}>{results}</div>
                                </div>
                            </div>
                        }
                    />
                )
                break
            }
        }
        return rows
    }

    toggleBookingEnabled() {
        this.setState({ bookingEnabled: !this.state.bookingEnabled })
    }

    renderTimeSelectOptions() {
        const options = []
        for (let h = 0; h < 13; h++) {
            let val = this.pad(h, 2) + ":00"
            options.push(
                <option key={val} value={val}>
                    {val}
                </option>
            )
            val = this.pad(h, 2) + ":30"
            options.push(
                <option key={val} value={val}>
                    {val}
                </option>
            )
        }
        return options
    }

    showProductPageUrl() {
        if (GlobalHelper.hasShopifyIntegration()) {
            return this.productExists()
        }
        return true
    }

    productPageUrlInputIsDisabled() {
        return GlobalHelper.hasShopifyIntegration()
    }

    defaultMatrix() {
        return {
            attributes: {
                xAxis: {
                    name: "Default",
                    options: [
                        {
                            id: uuidv4(),
                            attributes: {
                                name: "Default",
                                orderBy: 1
                            }
                        }
                    ]
                },
                yAxis: {
                    name: "Default",
                    options: [
                        {
                            id: uuidv4(),
                            attributes: {
                                name: "Default",
                                orderBy: 1
                            }
                        }
                    ]
                },
                zAxis: {
                    name: "Default",
                    options: [
                        {
                            id: uuidv4(),
                            attributes: {
                                name: "Default",
                                orderBy: 1
                            }
                        }
                    ]
                }
            }
        }
    }

    getBackLink(productType) {
        const parentProductId = this.props.match.params.parentId
        switch (productType) {
        case PRODUCT_TYPE.SINGLE:
            return "/products/catalog"
        case PRODUCT_TYPE.MATRIX_PARENT:
        case PRODUCT_TYPE.ASSEMBLY:
            return "/matrices/catalog"
        case PRODUCT_TYPE.MATRIX_ITEM:
            return !parentProductId ? "/matrices/catalog" : `/products/edit/${parentProductId}#${this.props.product.id}`
        default:
            return !parentProductId ? "/matrices/catalog" : `/products/edit/${parentProductId}`
        }
    }

    canDisplayCategorizationSection() {
        if (this.state.type != PRODUCT_TYPE.MATRIX_PARENT) {
            return true
        } else if (this.state.type === PRODUCT_TYPE.MATRIX_PARENT && GlobalHelper.IsFeatureFlagEnabled("displayMatrixCategorizationSection")) {
            return true
        }
        return false
    }

    render() {
        const hideBooking = this.state.bookingEnabled ? "" : "d-none"
        let hide = ""
        let matrixForm = ""
        if (this.state.type === PRODUCT_TYPE.MATRIX_PARENT) {
            if (GlobalHelper.IsFeatureFlagEnabled("matrixV2")) {
                matrixForm = (
                    <MatrixEditSectionWrapper
                        ref={this.matrixRef}
                        product={this.props.product}
                        onSave={() => this.submit(false)}
                        isFormDirty={this.isFormDirty()}
                    />
                )
            } else {
                const matrix = this.state.matrix || this.defaultMatrix()
                matrixForm = (
                    <MatrixEditForm
                        defaultUnitPrice={this.state.defaultUnitPrice}
                        defaultUnitCost={this.state.defaultUnitCost}
                        pricingStrategy={this.state.pricingStrategy}
                        billingMethods={this.state.billingMethods}
                        currency={this.state.currency}
                        onChange={this.onMatrixChange}
                        matrix={matrix}
                        unitOfMeasure={this.state.unitOfMeasure}
                    />
                )
            }
        }

        let deleteAction = ""
        if (this.state.productDeletedAt) {
            deleteAction = [
                <div className="col-3" key={"1"}>
                    <ActionButton
                        className={"btn btn-sm btn-warning mr-2 mb-2"}
                        onClick={this.unarchiveProduct}
                        isLoading={this.state.unarchiveLoading}
                    >
                        <FormattedMessage id="product.form.edit.unarchive_btn" defaultMessage="Unarchive" />
                    </ActionButton>
                </div>,
                <div className="col-9" key={"2"}>
                    <FormattedMessage
                        id="product.form.edit.archived_product_info"
                        defaultMessage="This product is archived and can't be found in search results."
                    />
                </div>
            ]
        } else if (this.state.id && this.props.product) {
            deleteAction = (
                <ConfirmButton
                    onModalRender={(m, c) => {
                        this.setState({ formStatus: m }, c)
                    }}
                    onClick={this.deleteProduct}
                    className="btn btn-danger"
                >
                    <FormattedMessage id="product.form.edit.delete_btn" defaultMessage="Delete product" />
                </ConfirmButton>
            )
        }

        let assemblyForm = ""
        if (this.state.type === PRODUCT_TYPE.ASSEMBLY) {
            assemblyForm = (
                <AssemblyEditForm
                    value={this.state.assembly}
                    onChange={this.handleAssemblyChange}
                    hasCalculator={this.state.hasCalculator}
                    terms={this.state.terms}
                    formulas={this.state.formulas}
                    unitOfMeasure={this.state.unitOfMeasure}
                />
            )
        }

        let calculatorForm = ""
        if (this.state.hasCalculator) {
            calculatorForm = <ConstraintEditForm value={this.state.terms} assembly={this.state.assembly} onChange={this.handleCalculatorChange} />
        }

        let pricingStrategy = (
            <div className={"mb-1 row "}>
                <label className="col-12 col-form-label custom-form-label strong" htmlFor="pricingStrategy">
                    <FormattedMessage id="product.form.edit.pricing_strategy_label" defaultMessage="Strategy" />
                </label>
                <div className="col-12">
                    <PricingStrategySelector
                        value={this.state.pricingStrategy}
                        onChange={strategy => {
                            this.setState({ pricingStrategy: strategy })
                            if (this.state.type === PRODUCT_TYPE.MATRIX_PARENT) {
                                this.props.updateProduct({
                                    updateType: PRODUCT_UPDATE_OPTION.PRICING_STRATEGY,
                                    value: strategy
                                })
                            }
                        }}
                    />
                </div>
            </div>
        )

        if (this.state.type === PRODUCT_TYPE.ASSEMBLY) {
            pricingStrategy = ""
        }

        let calculatorCheckBox = ""
        if (this.state.type === PRODUCT_TYPE.ASSEMBLY) {
            calculatorCheckBox = (
                <div className={"mb-1 row "}>
                    <div className="col-12">
                        <div className="custom-control custom-checkbox">
                            <input
                                type="checkbox"
                                name="hasCalculator"
                                checked={this.state.hasCalculator}
                                onChange={this.handleFormChange}
                                id="hasCalculator"
                                className="custom-control-input"
                            />
                            <label className="custom-control-label" htmlFor="hasCalculator">
                                <FormattedMessage id="product.form.edit.need_calculator_label" defaultMessage="Need a calculator" />
                            </label>
                        </div>
                    </div>
                </div>
            )
        }

        let linkedTo = ""
        if (this.state.externalLink) {
            switch (this.state.externalLink.attributes.integrationKey) {
            case "d-tools":
                linkedTo = (
                    <div className="mb-1 row">
                        <label className="col-12 col-form-label custom-form-label strong">
                            <FormattedMessage id="product.form.edit.linked_to_label" defaultMessage="Linked to system" />
                        </label>
                        <div className="col-12">
                            <img src="/images/d-tools_logo.png" width="80px" />
                        </div>
                    </div>
                )
                break
            }
        }

        const bookingIntegrations = AppContext.integrations
            .filter(i => i.attributes.features.includes("booking"))
            .map(i => i.attributes.integrationKey)

        const variantLimitReachedAlert = (
            <Alert
                alertHeader={this.props.intl.formatMessage(messages.reached_max_variants_header)}
                alertBody={this.props.intl.formatMessage(messages.reached_max_variants_body, {
                    currentVariantsCount: this.matrixRef?.current?.getItemsLength(),
                    maxNumber: MATRIX_ITEMS_LIMIT
                })}
                onClose={() => this.setState({ isVariantLimitAlertVisible: false })}
                dismissible={true}
                className="product-form-edit-component-alert-max-variant"
                variant="danger"
            />
        )

        return (
            <div className="row px-3">
                <div className="col-lg-8 col-12">
                    <div className="row ui-has-modules">
                        <div className="col-12 ui-module">
                            <div className="mb-1 row">
                                <label className="col-12 col-form-label custom-form-label strong" htmlFor="productTitle">
                                    <FormattedMessage id="product.form.edit.title_label" defaultMessage="Title" />
                                </label>
                                <div className="col-12">
                                    <input
                                        name="title"
                                        defaultValue={this.state.title}
                                        onBlur={this.handleFormChange}
                                        id="productTitle"
                                        type="text"
                                        className="form-control"
                                        placeholder={this.props.intl.formatMessage(messages["product_name_placeholder"])}
                                        disabled={this.state.type === PRODUCT_TYPE.MATRIX_ITEM}
                                    />
                                    <small className="form-text text-muted">
                                        <FormattedMessage
                                            id="product.form.edit.title_description"
                                            defaultMessage="Describe the product in a few word"
                                        />
                                    </small>
                                </div>
                            </div>
                            <div className="mb-1 row">
                                <label className="col-12 col-form-label custom-form-label strong" htmlFor="productShortDescription">
                                    <FormattedMessage id="product.form.edit.short_description_label" defaultMessage="Short Description" />
                                </label>
                                <div className="col-12">
                                    <textarea
                                        name="shortDescription"
                                        value={this.state.shortDescription}
                                        onChange={this.handleFormChange}
                                        id="productShortDescription"
                                        rows="3"
                                        className="form-control"
                                        placeholder={this.props.intl.formatMessage(messages["product_short_description_placeholder"])}
                                    />
                                    <small className="form-text text-muted">
                                        <FormattedMessage
                                            id="product.form.edit.short_description_description"
                                            defaultMessage="This description can be used on proposal on line items"
                                        />
                                    </small>
                                </div>
                            </div>
                            <div className={"mb-1 row"}>
                                <label className="col-12 col-form-label custom-form-label strong" htmlFor="productLongDescription">
                                    <FormattedMessage id="product.form.edit.long_description_label" defaultMessage="Long Description" />
                                </label>
                                <div className="col-12">
                                    <RichTextEditor
                                        enableMergeFields={true}
                                        height={400}
                                        name="longDescription"
                                        value={this.state.longDescription}
                                        onChange={this.handleRichTextChange}
                                        id="productLongDescription"
                                        className="form-control"
                                    />
                                    <small className="form-text text-muted">
                                        <FormattedMessage
                                            id="product.form.edit.long_description_description"
                                            defaultMessage="Rich description about all features of the product"
                                        />
                                    </small>
                                </div>
                            </div>

                            {this.showProductPageUrl() && (
                                <div className="mb-1 row">
                                    <label className="col-12 col-form-label custom-form-label strong" htmlFor="productPageUrl">
                                        <FormattedMessage id="product.form.edit.product_page_url_title" defaultMessage="Product Page" />
                                    </label>
                                    <div className="col-12">
                                        <input
                                            name="productPageUrl"
                                            value={this.state.productPageUrl}
                                            onChange={this.handleFormChange}
                                            id="productPageUrl"
                                            disabled={this.productPageUrlInputIsDisabled()}
                                            type="text"
                                            className="form-control"
                                            placeholder={this.props.intl.formatMessage(messages["product_page_url_placeholder"])}
                                        />
                                        <small className="form-text text-muted">
                                            <FormattedMessage
                                                id="product.form.edit.product_page_url_description"
                                                defaultMessage="Url of the product"
                                            />
                                        </small>
                                    </div>
                                </div>
                            )}
                            {![PRODUCT_TYPE.MATRIX_ITEM, PRODUCT_TYPE.MATRIX_PARENT].includes(this.state.type) && (
                                <CustomAttributeDefinitionForm
                                    isLoading={this.state.isLoading}
                                    customAttributeDefinitions={this.state.customAttributeDefinitions}
                                    onCustomAttributeDefnChange={customAttributes => {
                                        this.setState({
                                            customAttributeDefinitions: [...customAttributes]
                                        })
                                    }}
                                    onError={isError => {
                                        this.setState({
                                            isError: isError
                                        })
                                    }}
                                />
                            )}
                            {linkedTo}
                        </div>

                        <div className="col-12 ui-module">
                            <h4 className={"custom-lead"}>
                                <FormattedMessage id="product.form.edit.pricing.title" defaultMessage="Pricing" />
                            </h4>
                            <div className={"mb-1 row "}>
                                <label className="col-12 col-form-label custom-form-label strong" htmlFor="productUnitOfMeasure">
                                    <FormattedMessage id="product.form.edit.pricing.unit_of_measure_label" defaultMessage="Unit of Measure" />
                                </label>
                                <div className="col-12">
                                    <SelectUnitOfMeasure
                                        name="unitOfMeasure"
                                        required={true}
                                        value={this.state.unitOfMeasure}
                                        onChange={this.handleUnitOfMeasureChange}
                                    />
                                    <small className="form-text text-muted">
                                        <FormattedMessage
                                            id="product.form.edit.pricing.unit_of_measure_description"
                                            defaultMessage="The unit of measure used to define the quantity of the product or service"
                                        />
                                    </small>
                                </div>
                            </div>
                            <div className={"mb-1 row "}>
                                <label className="col-12 col-form-label custom-form-label strong" htmlFor="additionalUnitOfMeasure">
                                    <FormattedMessage
                                        id="product.form.edit.pricing.additional_unit_of_measure_label"
                                        defaultMessage="Combined quantity"
                                    />
                                </label>
                                <div className="col-12">
                                    <SelectUnitOfMeasure
                                        id={"additionalUnitOfMeasure"}
                                        name="additionalUnitOfMeasure"
                                        emptyLabel="none"
                                        required={false}
                                        value={this.state.additionalUnitOfMeasure}
                                        onChange={this.handleAdditionalUnitOfMeasureChange}
                                    />
                                    <small className="form-text text-muted">
                                        <FormattedMessage
                                            id="product.form.edit.pricing.additional_unit_of_measure_description"
                                            defaultMessage="The combined quantity will be multiplied by the quantity to calculate the price"
                                        />
                                    </small>
                                </div>
                            </div>

                            {this.state.type !== PRODUCT_TYPE.MATRIX_ITEM ? pricingStrategy : ""}
                            {GlobalHelper.IsFeatureFlagEnabled("billingMethods") &&
                                [PRODUCT_TYPE.SINGLE, PRODUCT_TYPE.MATRIX_PARENT].includes(this.state.type) && (
                                    <div className={"mb-1 row "}>
                                        <label className="col-12 col-form-label custom-form-label strong"
                                               htmlFor="billingMethods">
                                            <FormattedMessage id="product.form.edit.pricing.billing_methods_label" defaultMessage="Billing methods"/>
                                        </label>
                                        <div className="col-12">
                                            <BillingMethodSelector
                                                value={this.state.billingMethods}
                                                onChange={methods => {
                                                    this.setState({billingMethods: methods})
                                                    if (this.state.type === PRODUCT_TYPE.MATRIX_PARENT) {
                                                        this.props.updateProduct({
                                                            updateType: PRODUCT_UPDATE_OPTION.BILLING_METHOD,
                                                            value: methods
                                                        })
                                                    }
                                                }}
                                            />
                                            <small className="form-text text-muted">
                                                <FormattedMessage
                                                    id="product.form.edit.pricing.billing_methods_description"
                                                    defaultMessage="The billing method will help differentiate recurring revenue"
                                                />
                                            </small>
                                        </div>
                                    </div>
                                )
                            }
                            {this.renderPricingConfiguration(hide)}
                            <div className={"mb-1 row "}>
                                <label className="col-12 col-form-label custom-form-label strong" htmlFor="measureMinimum">
                                    <FormattedMessage id="product.form.edit.pricing.measure_minimum_label" defaultMessage="Minimum allowed" />
                                </label>
                                <div className="col-12">
                                    <div className="input-group">
                                        <InputUnitOfMeasure
                                            name="measureMinimum"
                                            value={this.state.measureMinimum}
                                            unit={this.state.unitOfMeasure}
                                            onChange={this.handleMeasureMinimumChange}
                                        />
                                    </div>
                                    <small className="form-text text-muted">
                                        <FormattedMessage
                                            id="product.form.edit.pricing.measure_minimum_description"
                                            defaultMessage="The measure minimum will calculate the price with the minimum amount if under"
                                        />
                                    </small>
                                </div>
                            </div>
                            <div className={"mb-1 row "}>
                                <div className="col-12">
                                    <div className="custom-control custom-checkbox">
                                        <input
                                            type="checkbox"
                                            className="custom-control-input"
                                            id="taxExempt"
                                            name="taxExempt"
                                            onChange={this.handleFormChange}
                                            checked={this.state.taxExempt}
                                        />
                                        <label className="custom-control-label" htmlFor="taxExempt">
                                            <FormattedMessage id="product.form.edit.pricing.tax_exempt_label" defaultMessage="Tax exempt" />
                                        </label>
                                    </div>
                                    <small className="form-text text-muted">
                                        <FormattedMessage
                                            id="product.form.edit.pricing.tax_exempt_description"
                                            defaultMessage="This option will exempt tax from the quote line when the product is added."
                                        />
                                    </small>
                                </div>
                            </div>
                            <div className={"mb-1 row "}>
                                <div className="col-12">
                                    <div className="custom-control custom-checkbox">
                                        <input
                                            type="checkbox"
                                            className="custom-control-input"
                                            id="feeExempt"
                                            name="feeExempt"
                                            onChange={this.handleFormChange}
                                            checked={this.state.feeExempt}
                                        />
                                        <label className="custom-control-label" htmlFor="feeExempt">
                                            <FormattedMessage id="product.form.edit.pricing.fee_exempt_label" defaultMessage="Exempt from fees" />
                                        </label>
                                    </div>
                                    <small className="form-text text-muted">
                                        <FormattedMessage
                                            id="product.form.edit.pricing.fee_exempt_description"
                                            defaultMessage="This option will exempt fee from the item line when the product is added."
                                        />
                                    </small>
                                </div>
                            </div>
                            {calculatorCheckBox}
                        </div>
                        {!this.state.isLoading && ![PRODUCT_TYPE.MATRIX_ITEM, PRODUCT_TYPE.MATRIX_PARENT].includes(this.state.type) && (
                            <ProductPriceEditForm
                                productPrices={this.state.productPrices?.map(p => new ProductPrice(p)) ?? []}
                                productExternalLinks={this?.props?.product?.attributes?.externalLinks.map(link => new ExternalLink(link)) || []}
                                isNewProduct={this.props.product ? false : true}
                                onChange={updatedProductPrices => {
                                    this.setState({ updatedProductPrices: updatedProductPrices })
                                }}
                            />
                        )}
                        {this.state.bookingFeatureEnabled ? (
                            <div className={"col-12 ui-module "}>
                                <h4 className={"custom-lead"}>
                                    <FormattedMessage id="product.form.edit.booking.title" defaultMessage="Booking specification" />
                                </h4>
                                <div className="form-group row">
                                    <label className="col-12 col-form-label custom-form-label strong" htmlFor="bookingEnabled">
                                        <FormattedMessage id="product.form.edit.enabled_label" defaultMessage="Enabled" />
                                    </label>
                                    <div className="col-12 pt-1">
                                        <Toggle
                                            id={"bookingEnabled"}
                                            defaultChecked={this.state.bookingEnabled}
                                            checked={this.state.bookingEnabled}
                                            icons={false}
                                            onChange={this.toggleBookingEnabled}
                                        />
                                    </div>
                                </div>
                                <div className={"mb-1 row " + hideBooking}>
                                    <label className="col-12 col-form-label custom-form-label strong" htmlFor="eventTitle">
                                        <FormattedMessage id="product.form.edit.event_title_label" defaultMessage="Event title" />
                                    </label>
                                    <div className="col-12">
                                        <input
                                            name="eventTitle"
                                            value={this.state.eventTitle}
                                            onChange={this.handleFormChange}
                                            id="eventTitle"
                                            type="text"
                                            className="form-control"
                                        />
                                        <small className="form-text text-muted">
                                            <FormattedMessage
                                                id="product.form.edit.event_title_description"
                                                defaultMessage="This is the subject of the event created in the calendar"
                                            />
                                        </small>
                                    </div>
                                </div>
                                <div className={"mb-1 row " + hideBooking}>
                                    <label className="col-12 col-form-label custom-form-label strong" htmlFor="eventDescription">
                                        <FormattedMessage id="product.form.edit.event_description_label" defaultMessage="Event description" />
                                    </label>
                                    <div className="col-12">
                                        <RichTextEditor
                                            height={200}
                                            name="eventDescription"
                                            value={this.state.eventDescription}
                                            onChange={val => {
                                                this.setState({ eventDescription: val })
                                            }}
                                            id="eventDescription"
                                            className="form-control"
                                        />
                                        <small className="form-text text-muted">
                                            <FormattedMessage
                                                id="product.form.edit.event_description_description"
                                                defaultMessage="Content of the event created in the calendar"
                                            />
                                        </small>
                                    </div>
                                </div>
                                <div className={"mb-1 row " + hideBooking}>
                                    <label className="col-12 col-form-label custom-form-label strong" htmlFor="eventDuration">
                                        <FormattedMessage id="product.form.edit.event_duration_label" defaultMessage="Event duration" />
                                    </label>
                                    <div className="col-12">
                                        <select
                                            name="eventDuration"
                                            value={this.state.eventDuration}
                                            onChange={this.handleFormChange}
                                            id="eventDuration"
                                            className="form-control"
                                        >
                                            {this.renderTimeSelectOptions()}
                                        </select>
                                        <small className="form-text text-muted">
                                            <FormattedMessage
                                                id="product.form.edit.event_duration_description"
                                                defaultMessage="Duration of the event created in the calendar"
                                            />
                                        </small>
                                    </div>
                                </div>
                                <div className={"mb-1 row " + hideBooking}>
                                    <label className="col-12 col-form-label custom-form-label strong" htmlFor="preBufferDuration">
                                        <FormattedMessage id="product.form.edit.pre_buffer_label" defaultMessage="Pre buffer duration" />
                                    </label>
                                    <div className="col-12">
                                        <select
                                            name="preBufferDuration"
                                            value={this.state.preBufferDuration}
                                            onChange={this.handleFormChange}
                                            id="preBufferDuration"
                                            className="form-control"
                                        >
                                            {this.renderTimeSelectOptions()}
                                        </select>
                                        <small className="form-text text-muted">
                                            <FormattedMessage
                                                id="product.form.edit.pre_buffer_description"
                                                defaultMessage="Duration of the buffer event created before the event"
                                            />
                                        </small>
                                    </div>
                                </div>
                                <div className={"mb-1 row " + hideBooking}>
                                    <label className="col-12 col-form-label custom-form-label strong" htmlFor="postBufferDuration">
                                        <FormattedMessage id="product.form.edit.post_buffer_label" defaultMessage="Post buffer duration" />
                                    </label>
                                    <div className="col-12">
                                        <select
                                            name="postBufferDuration"
                                            value={this.state.postBufferDuration}
                                            onChange={this.handleFormChange}
                                            id="postBufferDuration"
                                            className="form-control"
                                        >
                                            {this.renderTimeSelectOptions()}
                                        </select>
                                        <small className="form-text text-muted">
                                            <FormattedMessage
                                                id="product.form.edit.post_buffer_description"
                                                defaultMessage="Duration of the buffer event created after the event"
                                            />
                                        </small>
                                    </div>
                                </div>
                                <div className={"mb-1 row " + hideBooking}>
                                    <label className="col-12 col-form-label custom-form-label strong" htmlFor="calendars">
                                        <FormattedMessage id="product.form.edit.calendar_label" defaultMessage="Calendars associated to" />
                                    </label>
                                    <div className="col-12">
                                        <DeprecatedUserSelect
                                            filter={u => {
                                                return (
                                                    u.attributes.externalLinks.filter(l => bookingIntegrations.includes(l.attributes.integrationKey))
                                                        .length > 0
                                                )
                                            }}
                                            value={this.state.calendars}
                                            multi={true}
                                            onChange={val => {
                                                this.setState({ calendars: val })
                                            }}
                                        />
                                        <small className="form-text text-muted">
                                            <FormattedMessage
                                                id="product.form.edit.calendar_description"
                                                defaultMessage="User calendars allowed to book the event from"
                                            />
                                        </small>
                                    </div>
                                </div>
                            </div>
                        ) : (
                            ""
                        )}
                        {this.state.attachmentFeatureEnabled ? (
                            <div className={"col-12 ui-module "}>
                                <h4 className={"custom-lead"}>
                                    <FormattedMessage id="product.form.edit.attachment.calendly.title" defaultMessage="Calendly event types" />
                                </h4>
                                <div className={"form-group row "}>
                                    <label className="col-12 col-form-label custom-form-label strong" htmlFor="eventTitle">
                                        <FormattedMessage
                                            id="product.form.edit.attachment.calendly.choose_event_label"
                                            defaultMessage="Choose an event"
                                        />
                                    </label>
                                    <div className="col-12">
                                        <div className="card mb-2">
                                            <a
                                                href={"#"}
                                                onClick={e => {
                                                    e.preventDefault()
                                                    this.setState({
                                                        attachments: []
                                                    })
                                                }}
                                            >
                                                <div className="card-body d-flex align-items-center py-3">
                                                    <div className="custom-control custom-radio">
                                                        <input
                                                            type="radio"
                                                            id="none"
                                                            name="calendlyAttachment"
                                                            className="custom-control-input"
                                                            checked={this.state.attachments.length === 0}
                                                            onChange={e => {
                                                                if (e.target.checked) {
                                                                    this.setState({
                                                                        attachments: []
                                                                    })
                                                                }
                                                            }}
                                                        />
                                                        <label className="custom-control-label mb-0 pl-3" htmlFor={"none"}>
                                                            <FormattedMessage
                                                                id="product.form.edit.attachment.calendly.none_label"
                                                                defaultMessage="None"
                                                            />
                                                        </label>
                                                    </div>
                                                </div>
                                            </a>
                                        </div>
                                        {this.state.possibleAttachments.map((att, key) => {
                                            return (
                                                <div className="card mb-12" key={key}>
                                                    <a
                                                        className={"text-decoration-none"}
                                                        href={"#"}
                                                        onClick={e => {
                                                            e.preventDefault()
                                                            this.setState({
                                                                attachments: [
                                                                    {
                                                                        integrationKey: "calendly",
                                                                        externalId: att.id
                                                                    }
                                                                ]
                                                            })
                                                        }}
                                                    >
                                                        <div className="card-body d-flex align-items-center py-1">
                                                            <div className="custom-control custom-radio">
                                                                <input
                                                                    type="radio"
                                                                    id={att.id}
                                                                    name="calendlyAttachment"
                                                                    value={att.id}
                                                                    checked={
                                                                        this.state.attachments[0] && this.state.attachments[0].externalId === att.id
                                                                    }
                                                                    onChange={e => {
                                                                        if (e.target.checked) {
                                                                            this.setState({
                                                                                attachments: [
                                                                                    {
                                                                                        integrationKey: "calendly",
                                                                                        externalId: e.target.value
                                                                                    }
                                                                                ]
                                                                            })
                                                                        }
                                                                    }}
                                                                    className="custom-control-input"
                                                                />
                                                                <label className="custom-control-label text-white mb-0" htmlFor={att.id}>
                                                                    _
                                                                </label>
                                                            </div>
                                                            <div>
                                                                {att.attributes.imageUrl ? (
                                                                    <img
                                                                        className={"img-rounded mr-3 my-2"}
                                                                        width="75px"
                                                                        src={att.attributes.imageUrl}
                                                                    />
                                                                ) : (
                                                                    ""
                                                                )}
                                                            </div>
                                                            <div>
                                                                <h5 className="card-title border-0 mb-0 pb-1">{att.attributes.name}</h5>
                                                                <p className="card-text">{att.attributes.description}</p>
                                                            </div>
                                                        </div>
                                                    </a>
                                                </div>
                                            )
                                        })}
                                    </div>
                                </div>
                            </div>
                        ) : (
                            ""
                        )}
                    </div>
                </div>
                    
                {
                this.canDisplayCategorizationSection() && 
                    // {/* Categorization section */}           
                    (<div className="col-lg-4 col-12">
                        <div className="row ui-has-modules">
                            <div className={"col-12 ui-module " + hide}>
                                <h4 className={"custom-lead"}>
                                    <FormattedMessage id="product.form.edit.labels.title" defaultMessage="Categorization" />
                                </h4>
                                <div className="mb-1 row">
                                    <label className="col-12 col-form-label custom-form-label strong d-flex" htmlFor="sku">
                                        <FormattedMessage id="product.form.edit.sku_label" defaultMessage="Sku" />
                                        <span
                                            className={"ml-auto"}
                                            data-toggle="tooltip"
                                            data-html="true"
                                            title={this.props.intl.formatMessage(messages.sku_description)}
                                        >
                                            <Icon value={"info-circle"} className={"ml-1"} />
                                        </span>
                                    </label>
                                    <div className="col-12">
                                        <input
                                            name="sku"
                                            value={this.state.sku}
                                            onChange={this.handleFormChange}
                                            id="sku"
                                            type="text"
                                            className="form-control"
                                            placeholder={this.props.intl.formatMessage(messages["sku_placeholder"])}
                                        />
                                    </div>
                                </div>
                                <div className="mb-1 row">
                                    <label className="col-12 col-form-label custom-form-label strong d-flex" htmlFor="barcode">
                                        <FormattedMessage id="product.form.edit.barcode_label" defaultMessage="Barcode" />
                                        <span
                                            className={"ml-auto"}
                                            data-toggle="tooltip"
                                            data-html="true"
                                            title={this.props.intl.formatMessage(messages.barcode_description)}
                                        >
                                            <Icon value={"info-circle"} className={"ml-1"} />
                                        </span>
                                    </label>
                                    <div className="col-12">
                                        <input
                                            name="barcode"
                                            value={this.state.barcode}
                                            onChange={this.handleFormChange}
                                            id="barcode"
                                            type="text"
                                            className="form-control"
                                            placeholder={this.props.intl.formatMessage(messages["barcode_placeholder"])}
                                        />
                                    </div>
                                </div>
                                <div className="mb-1 row">
                                    <label className="col-12 col-form-label custom-form-label strong d-flex" htmlFor="upc">
                                        <FormattedMessage id="product.form.edit.upc_label" defaultMessage="UPC" />
                                        <span
                                            className={"ml-auto"}
                                            data-toggle="tooltip"
                                            data-html="true"
                                            title={this.props.intl.formatMessage(messages.upc_description)}
                                        >
                                            <Icon value={"info-circle"} className={"ml-1"} />
                                        </span>
                                    </label>
                                    <div className="col-12">
                                        <input
                                            name="upc"
                                            value={this.state.upc}
                                            onChange={this.handleFormChange}
                                            id="upc"
                                            type="text"
                                            className="form-control"
                                            placeholder={this.props.intl.formatMessage(messages["upc_placeholder"])}
                                        />
                                    </div>
                                </div>
                                <div className="mb-1 row">
                                    <label className="col-12 col-form-label custom-form-label strong d-flex" htmlFor="ean">
                                        <FormattedMessage id="product.form.edit.ean_label" defaultMessage="EAN" />
                                        <span
                                            className={"ml-auto"}
                                            data-toggle="tooltip"
                                            data-html="true"
                                            title={this.props.intl.formatMessage(messages.ean_description)}
                                        >
                                            <Icon value={"info-circle"} className={"ml-1"} />
                                        </span>
                                    </label>
                                    <div className="col-12">
                                        <input
                                            name="ean"
                                            value={this.state.ean}
                                            onChange={this.handleFormChange}
                                            id="ean"
                                            type="text"
                                            className="form-control"
                                            placeholder={this.props.intl.formatMessage(messages["ean_placeholder"])}
                                        />
                                    </div>
                                </div>
                                <div className="mb-1 row">
                                    <label className="col-12 col-form-label custom-form-label strong d-flex" htmlFor="manufacturerSku">
                                        <FormattedMessage id="product.form.edit.manufacturer_sku_label" defaultMessage="Manufacturer Sku" />
                                        <span
                                            className={"ml-auto"}
                                            data-toggle="tooltip"
                                            data-html="true"
                                            title={this.props.intl.formatMessage(messages.manufacturer_sku_description)}
                                        >
                                            <Icon value={"info-circle"} className={"ml-1"} />
                                        </span>
                                    </label>
                                    <div className="col-12">
                                        <input
                                            name="manufacturerSku"
                                            value={this.state.manufacturerSku}
                                            onChange={this.handleFormChange}
                                            id="manufacturerSku"
                                            type="text"
                                            className="form-control"
                                            placeholder={this.props.intl.formatMessage(messages["manufacturer_sku_placeholder"])}
                                        />
                                    </div>
                                </div>
                                <div className="mb-1 row">
                                    <label className="col-12 col-form-label custom-form-label strong d-flex" htmlFor="manufacturer">
                                        <FormattedMessage id="product.form.edit.labels.manufacturer_label" defaultMessage="Manufacturer" />
                                        <span
                                            className={"ml-auto"}
                                            data-toggle="tooltip"
                                            data-html="true"
                                            title={this.props.intl.formatMessage(messages.manufacturer_description)}
                                        >
                                            <Icon value={"info-circle"} className={"ml-1"} />
                                        </span>
                                    </label>
                                    <div className="col-12">
                                        <LabelSelect
                                            creatable={true}
                                            type="manufacturer"
                                            name="manufacturer"
                                            value={this.state.manufacturerIds}
                                            onChange={this.onManufacturersSelectChange}
                                            multi={true}
                                        />
                                    </div>
                                </div>
                                <div className="mb-1 row">
                                    <label className="col-12 col-form-label custom-form-label strong d-flex" htmlFor="vendor">
                                        <FormattedMessage id="product.form.edit.labels.vendor_label" defaultMessage="Vendor" />
                                        <span
                                            className={"ml-auto"}
                                            data-toggle="tooltip"
                                            data-html="true"
                                            title={this.props.intl.formatMessage(messages.vendor_description)}
                                        >
                                            <Icon value={"info-circle"} className={"ml-1"} />
                                        </span>
                                    </label>
                                    <div className="col-12">
                                        <LabelSelect
                                            creatable={true}
                                            type="vendor"
                                            name="vendor"
                                            value={this.state.vendorIds}
                                            onChange={this.onVendorSelectChange}
                                            multi={true}
                                        />
                                    </div>
                                </div>
                                <ProductBrandFieldSelect 
                                    selectedbrandId={this.state.brandId}
                                    onBrandSelectChange={this.onBrandSelectChange}
                                />
                                <div className="mb-1 row">
                                    <label className="col-12 col-form-label custom-form-label strong d-flex" htmlFor="tags">
                                        <FormattedMessage id="product.form.edit.labels.label_label" defaultMessage="Labels" />
                                        <span
                                            className={"ml-auto"}
                                            data-toggle="tooltip"
                                            data-html="true"
                                            title={this.props.intl.formatMessage(messages.label_description)}
                                        >
                                            <Icon value={"info-circle"} className={"ml-1"} />
                                        </span>
                                    </label>
                                    <div className="col-12">
                                        <LabelSelect
                                            creatable={true}
                                            type="tag"
                                            name="tags"
                                            value={this.state.tagIds}
                                            onChange={this.onTagsSelectChange}
                                            multi={true}
                                        />
                                    </div>
                                </div>
                                <div className="mb-1 mt-2 row">
                                    <div className="col-12">
                                        <div className="custom-control custom-checkbox">
                                            <input
                                                type="checkbox"
                                                className="custom-control-input"
                                                id="isNonInventory"
                                                name="isNonInventory"
                                                onChange={this.handleFormChange}
                                                checked={this.state.isNonInventory}
                                            />
                                            <label className="custom-control-label" htmlFor="isNonInventory">
                                                <FormattedMessage id="product.form.edit.labels.non_inventory_label" defaultMessage="Non inventory" />
                                            </label>
                                        </div>
                                        <small className="form-text text-muted">
                                            <FormattedMessage
                                                id="product.form.edit.pricing.non_inventory_description"
                                                defaultMessage="Check this box if it is a non inventory item such as services."
                                            />
                                        </small>
                                    </div>
                                </div>
                            </div>
                            <div className={"col-12 ui-module "}>
                                <h4 className={"custom-lead"}>
                                    <FormattedMessage id="product.form.edit.images.title" defaultMessage="Images" />
                                </h4>
                                <div className="form-group row">
                                    <div className="col-12">
                                        <ImageUploaderDropZone onUpdateImageList={this.handleImageChange} maxFiles={5} images={this.state.images} />
                                    </div>
                                </div>
                            </div>
                            <div className={"col-12 ui-module "}>
                                <h4 className={"custom-lead"}>
                                    <FormattedMessage id="product.form.edit.documents.title" defaultMessage="Documents" />
                                </h4>
                                <div className="form-group row">
                                    <div className="col-12">
                                        <DocumentUploaderDropZone
                                            onUpdateDocumentList={this.handleDocumentChange}
                                            maxFiles={5}
                                            documents={this.state.documents}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                        {calculatorForm}
                        {assemblyForm}
                    </div>
                )}    

                <div className="col-12">
                    <div className="ui-has-modules p-0">
                        {matrixForm}
                        <div className="col-12 mb-5">
                            {this.state.formStatus}
                            {this.state.modal}
                        </div>

                        <div className="row m-0 py-1 fixed-bottom pr-0 pr-md-5 pr-xl-0">
                            {this.state.isVariantLimitAlertVisible && variantLimitReachedAlert}
                            <div className={"col-lg-12 mx-auto col-xl-11 pt-3 pl-4 pr-4 pr-md-5 pr-xl-4"}>
                                <div className="col-12 ui-module sticky-bottom-module">
                                    {this.state.type === PRODUCT_TYPE.MATRIX_PARENT ? (
                                        <div className="row">
                                            <div className="col-6">{deleteAction}</div>
                                            <div className="col-6 text-align-right">
                                                <Link to={this.getBackLink(this.state.type)} className="btn btn-light">
                                                    <FormattedMessage id="product.form.edit.cancel_btn" defaultMessage="Cancel" />
                                                </Link>
                                                &nbsp; &nbsp;
                                                <ActionButton
                                                    isLoading={this.state.isSubmitting}
                                                    onClick={() => {
                                                        if (this.matrixRef?.current?.getItemsLength() > MATRIX_ITEMS_LIMIT) {
                                                            this.setState({ isVariantLimitAlertVisible: true })
                                                        } else {
                                                            this.submit(true)
                                                        }
                                                    }}
                                                    className="btn btn-primary"
                                                    disabled={this.state.isError || this.state.title === "" || this.state.isVariantLimitAlertVisible}
                                                >
                                                    <FormattedMessage id="product.form.edit.save_btn" defaultMessage="Save" />
                                                </ActionButton>
                                            </div>
                                        </div>
                                    ) : (
                                        <div className="row">
                                            <div className="col-6">{deleteAction}</div>
                                            <div className="col-6 text-align-right">
                                                <Link to={this.getBackLink(this.state.type)} className="btn btn-light">
                                                    <FormattedMessage id="product.form.edit.cancel_btn" defaultMessage="Cancel" />
                                                </Link>
                                                &nbsp; &nbsp;
                                                <ActionButton
                                                    isLoading={this.state.isSubmitting}
                                                    onClick={() => this.submit(true)}
                                                    className="btn btn-primary"
                                                    disabled={this.state.isError || this.state.title === ""}
                                                >
                                                    <FormattedMessage id="product.form.edit.save_btn" defaultMessage="Save" />
                                                </ActionButton>
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

const mapState = (state, props) => {
    return { ...props }
}
const mapDispatch = {
    updateProduct
}
const connector = connect(mapState, mapDispatch)
export default connector(injectIntl(withRouter(ProductEditForm)))



// WEBPACK FOOTER //
// ./src/product/form/edit.component.jsx